// mediaTagging/tagInteractions.js — which interaction adapters a tagging session gets.
//
// Read-only sessions (tagsRead without tagsWrite, plan backend_permission-system_firststeps) get no drawing, no
// drag and no resize. Pure decision, kept out of TaggingCore so it is testable without jQuery.

import { JQueryUIDraggableAdapter } from './adapter/JQueryUIDraggableAdapter.js';
import { JQueryUIResizableAdapter } from './adapter/JQueryUIResizableAdapter.js';
import { MouseDrawingAdapter } from './adapter/MouseDrawingAdapter.js';

// Stands in for MouseDrawingAdapter when nothing may be drawn — TaggingCore calls attach/detach/isDrawing unconditionally.
export const NO_DRAWING = Object.freeze({ attach() {}, detach() {}, isDrawing: () => false });

export function resolveTagInteractions({ readOnly = false, interactions = {} } = {}) {
    if (readOnly) { return { draggable: null, resizable: null, drawing: NO_DRAWING }; }
    const {
        draggable = new JQueryUIDraggableAdapter(),
        resizable = new JQueryUIResizableAdapter(),
        drawing   = new MouseDrawingAdapter(),
    } = interactions;
    return { draggable, resizable, drawing };
}
